/* eslint-disable import-x/order */
import './set-webpack-path';
import 'util/Globals';

import {markInitialImportFinished} from 'util/StartImportTracker';
import markPageInitFinished from 'util/markPageInitFinished';
import Router from 'routing/Router';

// @ts-expect-error
import ProtocolsRouter from './RouterProtocol';
import mainRunner, {hotReload} from './util/MainRunner';

markInitialImportFinished();

if (process.env.NODE_ENV === 'development') {
  // Production build will skip this if block, preventing devInit from being bundled.
  const devInit = require('dev/devInit').default;
  devInit();
}

mainRunner([Router, ProtocolsRouter]);

// webpack HMR
if (module.hot) {
  module.hot.accept(['routing/Router', './RouterProtocol'], () => {
    const NextRouter = require('routing/Router').default;
    const NextProtocolsRouter = require('./RouterProtocol').default;
    hotReload([NextRouter, NextProtocolsRouter]);
  });
}

markPageInitFinished();
